import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, isRef as _isRef, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/mine_ic_change@2x.png'


const _withScopeId = n => (_pushScopeId("data-v-e3c5d39c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "box_info" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "box_info_box" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_6 = { class: "box_function" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "box_function_item_left" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "box_function_item_right" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "退出登录", -1))
const _hoisted_12 = [
  _hoisted_11
]

import { ref } from 'vue'
    import { useRouter } from 'vue-router'
    import { useStore } from "vuex"
    import { Dialog, Toast } from 'vant'
    import { changeCom, getDepartmentListByConditon } from '@/apis/PersonalAPI'
    import { wxLoginOut } from '@/apis'

    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const VanDialog = Dialog.Component;
    const router = useRouter()

    const store = useStore()

    let show = ref<boolean>(false)   // 控制切换组织弹框

    let columns = ref([]);     // 组织数据

    let avatar: any = require('@/assets/icon/2@2x.png')     // 默认头像

    const MENU = ref([
        { name: '个人信息', url: '/personal/personalInformation', icon: require('@/assets/icon/mine_ic_gerenxinxi@2x.png') },
        // { name: '系统通知', url: '', icon: require('@/assets/icon/mine_ic_xitonggonggao@2x.png') },
        { name: '更新手机号', url: '/personal/updatePhone', icon: require('@/assets/icon/mine_ic_shoujihao@2x.png') },
        { name: '更新邮箱号', url: '/personal/updateMailbox', icon: require('@/assets/icon/mine_ic_youxianghao@2x.png') },
        { name: '扫码绑定账号', url: '', icon: require('@/assets/icon/mine_ic_bangding@2x.png') },
        { name: '修改密码', url: '/personal/changePassword', icon: require('@/assets/icon/mine_ic_xiugaimima@2x.png') },
    ])

    // 确认切换组织
    const onConfirm = (value: any): void => {
        changeCom(value.id).then(res => {
            show.value = false
            Toast.success({ message: '更新组织成功' })
            store.dispatch('getUserInfos')
        })
    };

    // 退出登录
    const loginOut = () => {
        wxLoginOut({
            companyUserId: store.state.userInfo.companyUser.id
        }).then(res => {
            if (res.code === 200) {
                // window.parent.postMessage('阿康', '*')
                // let href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx6ea339a336f26380&redirect_url=https://www.mes.red/h5/redirect.html&response_type=code&scope=snsapi_base&state=#wechat_redirect'
                let href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx6ea339a336f26380&redirect_url=https://dmtest.ahapp.net/doumeeplant_h5/redirect.html&response_type=code&scope=snsapi_base&state=#wechat_redirect'
                window.open(href)
            }
        })
    }

    // 关闭组织弹框
    const onCancel = (): void => {
        show.value = false
    }

    // 跳转页面
    const JUMP = (url: string): void => {
        url ? router.push({ path: url }) : ''
    }

    // 切换组织
    const switchOrganization = (): void => {
        getDepartmentListByConditon({
            type: 0
        }).then(res => {
            if (res.code === 200) {
                columns.value = []
                res.data.forEach((item: any) => {
                    let obj: any = {
                        text: item.name, id: item.id
                    }
                    columns.value.push(obj as never)
                })
                show.value = true
            }
        })

    }

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_picker = _resolveComponent("van-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          src: _unref(store).state.userInfo.avatar ? _unref(store).state.userInfo.avatar : _unref(avatar),
          alt: ""
        }, null, 8, _hoisted_3),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", null, _toDisplayString(_unref(store).state.userInfo.companyUser ? _unref(store).state.userInfo.companyUser.name : ''), 1),
          _createElementVNode("div", {
            class: "box_info_box_x",
            onClick: switchOrganization
          }, [
            _createElementVNode("span", null, _toDisplayString(_unref(store).state.userInfo.curComDepartment ? _unref(store).state.userInfo.curComDepartment.name : ''), 1),
            _hoisted_5
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(MENU.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "box_function_item",
            key: index,
            onClick: ($event: any) => (JUMP(item.url))
          }, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("img", {
                src: item.icon,
                alt: ""
              }, null, 8, _hoisted_9),
              _createElementVNode("span", null, _toDisplayString(item.name), 1)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_van_icon, {
                name: "arrow",
                size: "20",
                color: "#CCCCCC"
              })
            ])
          ], 8, _hoisted_7))
        }), 128))
      ]),
      (_unref(store).state.env && (_unref(store).state.env == 'WX' || _unref(store).state.env == 'XCX'))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "box_out",
            onClick: loginOut
          }, _hoisted_12))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_van_popup, {
      show: _unref(show),
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => (_isRef(show) ? (show).value = $event : show = $event)),
      position: "bottom",
      round: "",
      style: { height: '50%' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_picker, {
          title: "请选择组织",
          columns: _unref(columns),
          onConfirm: onConfirm,
          onCancel: onCancel
        }, null, 8, ["columns"])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})